import React, { useState } from 'react';
import { css } from '@emotion/react';
import { toast } from 'react-toastify';
import { fetchWrapper } from '../../../../_helpers';
import { Switch } from '@/_elements/FormElements';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';

const Component = ({ conferenceId, conferenceSettings, updateConferenceSettings = () => {} }) => {
    const [loading, setLoading] = useState(false);

    const accessType = conferenceSettings?.accessType || 'trusted';

    const handleToggle = async (e) => {
        const newAccessType = e.target.checked ? 'open' : 'trusted';
        setLoading(true);
        try {
            const response = await fetchWrapper.patch(`/conference/${conferenceId}/settings`, {
                accessType: newAccessType,
            });

            updateConferenceSettings({
                ...conferenceSettings,
                accessType: (response?.settings || {})?.accessType || newAccessType,
            });

            toast.success(`Meeting is now ${newAccessType === 'open' ? 'Open to Guests' : 'Trusted Only'}`);
        } catch (error) {
            console.error(error);
            toast.error('Failed to update settings');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            css={css`
                padding: 1rem;
                color: white;
            `}
        >
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h3 className="mb-1">Guest Access</h3>
                </div>

                <Switch
                    id="guest-access-switch"
                    label=""
                    checked={accessType === 'open'}
                    onChange={handleToggle}
                    disabled={loading}
                    disableTextClick={true}
                />
            </div>
            <div
                css={css`
                    background: rgba(255, 255, 255, 0.1);
                    padding: 10px;
                    border-radius: 5px;
                    margin-top: 10px;
                `}
            >
                <strong>{accessType === 'open' ? 'Open Meeting' : 'Trusted Meeting'}</strong>
                <p className="mb-0 mt-1">
                    {accessType === 'open'
                        ? 'Anyone with the link can join as a guest.'
                        : 'Only optonome logged-in users can join.'}
                </p>
            </div>
        </div>
    );
};

const Settings = (props) => {
    return (
        <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
            <Component {...props} />
        </ComponentErrorBoundary>
    );
};

export default Settings;
